module.exports = __webpack_public_path__ + "static/idhp-logo.533b24fc.svg";